function addEvent(event, selector, callback, context) {
  document.addEventListener(event, e => {
      if ( e.target.closest(selector) ) {
          callback(e);
      }
  });
}
addEvent('click', '.cmplz-show-banner', function(){
  document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
      obj.click();
  });
});
